export default __webpack_public_path__ + "static/media/about-us.4128712a.jpg";